import { makeAutoObservable } from 'mobx'
import { RootStore } from 'stores'
import { IFilter } from 'types/common/query'
import { handleError } from 'API'
import { countTags, createTag, getTagDetail, getTags, updateTag } from 'API/tag'
import { ITag } from 'interfaces/tag'

export default class TagStore {
  rootStore: RootStore

  tags: ITag[] = []
  tagsLength: number = 0
  tagDetail: ITag = {}

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore
    makeAutoObservable(this)
  }

  async fetchTags(filter: IFilter<ITag> = {}): Promise<ITag[]> {
    try {
      const tags: ITag[] = await getTags(filter)
      this.tags = tags
      return tags
    } catch (error: any) {
      handleError(error as Error, 'stores/cms/cmsTagStore.ts', 'fetchTags')
      return []
    }
  }

  async fetchCMSTagList(filter: IFilter<ITag> = {}): Promise<void> {
    try {
      const [tagList, tagCount] = await Promise.all([getTags(filter), countTags(filter?.where ?? {})])
      this.tags = tagList
      this.tagsLength = tagCount
    } catch (error: any) {
      handleError(error as Error, 'stores/cms/cmsTagStore.ts', 'fetchCMSTagList')
    }
  }

  async fetchTagDetail(id: string, filter: IFilter<ITag> = {}): Promise<void> {
    try {
      const tag: ITag = await getTagDetail(id, filter)
      this.tagDetail = tag
    } catch (error: any) {
      handleError(error as Error, 'stores/cms/cmsTagStore.ts', 'fetchTagDetail')
    }
  }

  async createNewTag(tag: ITag): Promise<void> {
    try {
      const newTag: ITag = await createTag(tag)
      this.tagDetail = newTag as ITag
    } catch (error: any) {
      handleError(error as Error, 'stores/cms/cmsTagStore.ts', 'createTag')
    }
  }

  async updateExistedTag(id: number, tag: ITag): Promise<void> {
    try {
      await updateTag(id, tag)
    } catch (error: any) {
      handleError(error as Error, 'stores/cms/cmsTagStore.ts', 'updateTag')
    }
  }

  selectTag(id: number): void {
    if (!id) {
      this.tagDetail = {}
      return
    }
    this.tagDetail = this.tags.find(tag => tag?.id === id) ?? {}
  }

  resetStore(): void {
    this.tagDetail = {}
    this.tags = []
  }
}
